import InboxMetaAPI from '../../api/inboxMeta';

const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

const state = {
  groups: [],
  fetchedAt: null,
  isLoading: false,
};

export const getters = {
  getGroups: $state => $state.groups,
  isLoading: $state => $state.isLoading,
  isCacheValid: $state => {
    if (!$state.fetchedAt) return false;
    return Date.now() - $state.fetchedAt < CACHE_TTL;
  },
};

export const actions = {
  fetchGroups: async ({ commit, state: $state, getters: $getters }, evolutionInboxes) => {
    if ($getters.isCacheValid && $state.groups.length > 0) return;
    if ($state.isLoading) return;

    commit('SET_LOADING', true);

    const groups = [];

    for (let i = 0; i < evolutionInboxes.length; i++) {
      try {
        const { data } = await InboxMetaAPI.fetchEvolutionGroups(
          evolutionInboxes[i].id
        );
        const fetched = data.groups || [];
        for (const group of fetched) {
          if (group.isCommunity) continue;
          if (!groups.some(g => g.id === group.id)) {
            groups.push(group);
          }
        }
      } catch {
        // Silently skip failed inboxes
      }

      // 3s backoff between calls (except last)
      if (i < evolutionInboxes.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 3000));
      }
    }

    commit('SET_GROUPS', groups);
    commit('SET_FETCHED_AT', Date.now());
    commit('SET_LOADING', false);
  },

  clearCache: ({ commit }) => {
    commit('CLEAR_CACHE');
  },
};

export const mutations = {
  SET_GROUPS: ($state, groups) => {
    $state.groups = groups;
  },
  SET_FETCHED_AT: ($state, timestamp) => {
    $state.fetchedAt = timestamp;
  },
  SET_LOADING: ($state, value) => {
    $state.isLoading = value;
  },
  CLEAR_CACHE: $state => {
    $state.groups = [];
    $state.fetchedAt = null;
    $state.isLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
